import { useMemo } from 'react';
import BooleanInputs from './BooleanInputs';
import { inputStyle as inputStyleClass } from './Survey.css';
import { getInputStyle } from './utils';

interface Props {
  name: string;
  type: string;
  required: boolean;
  inputStyle?: React.CSSProperties;
  isHidden?: boolean;
}

const ShortText = ({ name, type, required, inputStyle = {}, isHidden = false }: Props) => {
  const style = useMemo(() => getInputStyle(inputStyle), [inputStyle]);

  switch (type) {
    case 'email':
      return (
        <input
          className={inputStyleClass}
          style={style}
          name="email"
          type="email"
          hidden={isHidden}
          required={required}
          placeholder="Email"
          id="email"
        />
      );
    case 'string':
      return (
        <input
          className={inputStyleClass}
          style={style}
          name={name}
          type="text"
          required={required}
          placeholder="Please type your response here"
          id={name}
        />
      );
    case 'integer':
      return (
        <input
          className={inputStyleClass}
          style={style}
          name={name}
          type="number"
          required={required}
          placeholder="Number"
          id={name}
        />
      );
    case 'boolean':
      return <BooleanInputs name={name} required={required} />;
    case 'date':
      return (
        <input
          className={inputStyleClass}
          style={style}
          name={name}
          type="date"
          placeholder="date"
          required={required}
          id={name}
        />
      );
    case 'datetime':
      return (
        <input
          className={inputStyleClass}
          style={style}
          name={name}
          type="time"
          placeholder="time"
          required={required}
          id={name}
        />
      );
    default:
      return (
        <input
          className={inputStyleClass}
          style={style}
          name={name}
          type="text"
          placeholder="Please type your response here"
          required={required}
          id={name}
        />
      );
  }
};

export default ShortText;
